export default __webpack_public_path__ + "static/media/step3.7bbbe12d.png";